import { Button } from '@lifeomic/chroma-react/components/Button';
import React from 'react';
import { useIntl } from 'react-intl';
import { messages } from '../messages';
import { useRequestExecutiveSummary } from './useRequestExecutiveSummary';

type RegenerateActionItemsProps = {
  patientId: string;
  onGenerate: () => void;
};

export const RegenerateActionItems: React.FC<RegenerateActionItemsProps> = ({
  patientId,
  onGenerate,
}) => {
  const { requestExecutiveSummary } = useRequestExecutiveSummary({ patientId });
  const { formatMessage } = useIntl();

  const handleClick = () => {
    requestExecutiveSummary(
      {
        requestedSummaries: [], // do not regenerate any summaries
        skipActionItems: false, // include action items when regenerating action plan explicitly
      },
      { isRegenerate: true },
    );
    onGenerate?.();
  };

  return (
    <Button onClick={handleClick} fullWidth>
      {formatMessage(messages.regenerateActionPlan)}
    </Button>
  );
};
